import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import ReactCodeInput from 'react-code-input';
import ErrorModal from '../../../../../components/ErrorModal/ErrorModal';
import commonUtil from '../../../../../utils/commonUtil';
import { submitTransference } from '../../actions';

const TimerComponent = ({ timer }) => {
  const time = `${timer}`;
  const timerClock = `00:${time.length === 1 ? '0' + timer : timer}`;
  return (
    <span style={{ fontWeight: 600 }}>
      {timer > 30 ? '00:00' : timerClock }
    </span>
  );
};

class OtpCodeValidationModal extends Component {
  constructor(props) {
    super(props);
    this.applicationRoutes = commonUtil.getApplicationRoutes();
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.submitTransferenceDataDetails = '';
    this.eventID = this.props.eventId;
    this.isEmployee = this.props.submitTransferenceData.transferenceData.isEmployee;
    this.type = this.props.type;
    this.submitTransferenceData = null;
    this.state = {
      otpCode: 0,
      show: false,
      isCodeValid: true,
      disabledButton: true,
      timer: 1000,
      messageError: '',
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      if (this.state.timer > 0) {
        this.setState(state => ({
          ...state,
          timer: this.state.timer - 1,
        }));
      } else {
        this.setState(state => ({
          ...state,
          disabledButton: false,
          timer: 1000,
        }));
      }
    }, 1000);
    this.props.onRef(this);
  }

  componentWillUnmount() { this.props.onRef(undefined); this.stopTimer(); }

  stopTimer = () => { clearInterval(this.interval); };

  handleClose = () => {
    this.clear();
    this.setState({ otpCode: 0, isCodeValid: true, messageError: '', show: false, timer: 1000 });
  }

  handleShow() {
    this.setState({ otpCode: 0, show: true, timer: 30 });
  }

  initTimeWap() {
    this.setState({ otpCode: 0, timer: 45 });
  }

  clear = () => {
    for (let index = 0; index < 6; index++) {
      this.reactCodeInput.state.input[index] = '';
      this.reactCodeInput.textInput[index].value = '';
    }
    this.reactCodeInput.textInput[0].focus();
  }

  handleCodeChange = async (code) => {
    await this.setState({ 
      otpCode: code, 
      isCodeValid: (code.length > 0) ? true : this.state.isCodeValid,  
      messageError: (code.length > 0) ? '' : this.state.messageError 
    });
    if (this.state.otpCode.length === 6) {
      this.validateOtpCode(this.state.otpCode);
    }
  }

  validateOtpCode = async (otpCode) => {
    const isPartial = this.props.type === 'partial';
    const response = await this.props.validateOtp(otpCode);
    if (response.success) {
      this.handleClose();
      if (isPartial) {
        await this.callSubmitTransferencePartial();
      } else {
        await this.callSubmitTransferenceClose();
      }
    } else {
      this.setState({ isCodeValid: false, messageError: response.message });
      this.clear();
    }
  }

  handleBtnSendAgain = async () => {
    await this.setState(state => ({
      ...state,
      disabledButton: true,
      timer: 30,
      isCodeValid: true,
      messageError: '',
      otpCode: 0,
    }));
    this.props.createOtp();
  }

  callSubmitTransferenceClose = async () => {
    this.submitTransferenceDataDetails = Object.assign({}, this.props.submitTransferenceData);
    // if (this.submitTransferenceDataDetails.submitTransferenceData.walletOrEmployeeIdentifierId) {
    //   if (this.submitTransferenceDataDetails.transferenceData.isEmployee.toString() !== 'true') {
    //     this.submitTransferenceDataDetails.submitTransferenceData.walletType = '0';
    //   }
    // }
    // if (this.submitTransferenceDataDetails.submitTransferenceData.cardOrBankIdentifierId) {
    //   this.submitTransferenceDataDetails.submitTransferenceData.paymentType = '2';
    // }

    let userName = this.submitTransferenceDataDetails.submitTransferenceData.userName || this.submitTransferenceDataDetails.submitTransferenceData.walletUserName || this.submitTransferenceDataDetails.submitTransferenceData.walletHolderName || "";

    let submitTransferenceDetails = {
      transactionStatusObject : {
        currTime: Date.now(),
        monederoAccountInfo: {
          accountId: this.submitTransferenceDataDetails.submitTransferenceData.cardOrBankIdentifierId || this.submitTransferenceDataDetails.submitTransferenceData.walletOrEmployeeIdentifierId || '',
          number: this.submitTransferenceDataDetails.submitTransferenceData.walletNumber || '',
          walletType: this.submitTransferenceDataDetails.submitTransferenceData.walletType || '',
          transferAmount: this.submitTransferenceDataDetails.submitTransferenceData.totalAmount || '0.00',
          commission: this.submitTransferenceDataDetails.submitTransferenceData.commissionValue ||  ".00",
          totalAmount: this.submitTransferenceDataDetails.submitTransferenceData.totalAmount || '0.00',
          bonusAmount: this.submitTransferenceDataDetails.submitTransferenceData.bonusAmount || 0,
          bonusPercentage: this.submitTransferenceDataDetails.submitTransferenceData.bonusPercentage || "0",
          commissionPercentage: '0',
          userName: userName,
        },
        bankOrCardInfo:{
          accountId: this.submitTransferenceDataDetails.submitTransferenceData.cardOrBankIdentifierId || this.submitTransferenceDataDetails.submitTransferenceData.walletOrEmployeeIdentifierId || '',
          number: this.submitTransferenceDataDetails.submitTransferenceData.walletNumber || '',
          paymentType: this.submitTransferenceDataDetails.submitTransferenceData.paymentType || '',
          transferAmount: this.submitTransferenceDataDetails.submitTransferenceData.totalAmount || '0.00',
          commission: this.submitTransferenceDataDetails.submitTransferenceData.commissionValue ||  ".00",
          totalAmount: this.submitTransferenceDataDetails.submitTransferenceData.totalAmount || '0.00',
          bonusAmount: this.submitTransferenceDataDetails.submitTransferenceData.bonusAmount || 0,
          commissionPercentage: '0',
          userName: userName,
        },
        closingGiftDetails: this.submitTransferenceDataDetails.submitTransferenceData.gifts || [],
      }
    }

    if (
      this.submitTransferenceDataDetails.submitTransferenceData.totalAmount === null ||
      this.submitTransferenceDataDetails.submitTransferenceData.totalAmount === undefined ||
      isNaN(this.submitTransferenceDataDetails.submitTransferenceData.totalAmount)
    ) {
      this.submitTransferenceDataDetails.submitTransferenceData.totalAmount = "0.00";
    }

    delete this.submitTransferenceDataDetails.submitTransferenceData.commissionValue;
    delete this.submitTransferenceDataDetails.submitTransferenceData.accountNumber;
    delete this.submitTransferenceDataDetails.submitTransferenceData.transferDate;
    delete this.submitTransferenceDataDetails.submitTransferenceData.cardNumber;
    delete this.submitTransferenceDataDetails.submitTransferenceData.paymentMode;
    delete this.submitTransferenceDataDetails.submitTransferenceData.bonusPercentage;
    delete this.submitTransferenceDataDetails.submitTransferenceData.commissionValue_CardBank;
    delete this.submitTransferenceDataDetails.submitTransferenceData.totalAmount_CardBank_View;
    delete this.submitTransferenceDataDetails.submitTransferenceData.totalAmount_View;
    delete this.submitTransferenceDataDetails.submitTransferenceData.walletUserName;
    delete this.submitTransferenceDataDetails.submitTransferenceData.cardBankUserName;
    delete this.submitTransferenceDataDetails.submitTransferenceData.skusNames;
    delete this.submitTransferenceDataDetails.submitTransferenceData.selectedAddressName;
    delete this.submitTransferenceDataDetails.submitTransferenceData.gifts;
    if (!this.submitTransferenceDataDetails.submitTransferenceData.selectedAddressId) {
      delete this.submitTransferenceDataDetails.submitTransferenceData.selectedAddressId;
    }

    await submitTransference(this.submitTransferenceDataDetails.submitTransferenceData).then((res) => {
    if (res.body.status !== 'failure') {
      this.handleClose();
      browserHistory.push(
        {
          pathname: commonUtil.getRouteByParameter(this.applicationRoutes.closureConfirmation,
            { eventID: this.eventID }),
          state: {
            submitTransferenceDetails: submitTransferenceDetails, isEmployee: this.isEmployee,
          },
        });
    } else {
      this.openErrorModal();
    }
    }).catch((e) => {
      const errorMessage = e.body?.status === 'failure' ? e.body?.message ?? "" : "";
      this.openErrorModal(errorMessage);
    });
  }

  callSubmitTransferencePartial = async () => {
    this.submitTransferenceDataDetails = Object.assign({}, this.props.submitTransferenceData);
    // if (this.submitTransferenceDataDetails.submitTransferenceData.cardOrBankIdentifierId) {
    //   this.submitTransferenceDataDetails.submitTransferenceData.paymentType = '2';
    // }

    let userName = this.submitTransferenceDataDetails.submitTransferenceData.userName || this.submitTransferenceDataDetails.submitTransferenceData.walletUserName || this.submitTransferenceDataDetails.submitTransferenceData.walletHolderName || "";

    let submitTransferenceDetails = {
      transactionStatusObject : {
        currTime: Date.now(),
        monederoAccountInfo: {
          accountId: this.submitTransferenceDataDetails.submitTransferenceData.walletOrEmployeeIdentifierId || this.submitTransferenceDataDetails.submitTransferenceData.cardOrBankIdentifierId || '',
          number: this.submitTransferenceDataDetails.submitTransferenceData.walletNumber || '',
          walletType: this.submitTransferenceDataDetails.submitTransferenceData.walletType || '',
          transferAmount: this.submitTransferenceDataDetails.submitTransferenceData.totalAmount || '0.00',
          commission: this.submitTransferenceDataDetails.submitTransferenceData.commissionValue ||  ".00",
          totalAmount: this.submitTransferenceDataDetails.submitTransferenceData.totalAmount || '0.00',
          bonusAmount: this.submitTransferenceDataDetails.submitTransferenceData.bonusAmount || 0,
          commissionPercentage: '0',
          userName: userName,
        },
        bankOrCardInfo:{
          accountId: this.submitTransferenceDataDetails.submitTransferenceData.cardOrBankIdentifierId || this.submitTransferenceDataDetails.submitTransferenceData.walletOrEmployeeIdentifierId || '',
          number: this.submitTransferenceDataDetails.submitTransferenceData.cardNumber || this.submitTransferenceDataDetails.submitTransferenceData.walletNumber || '',
          paymentType: this.submitTransferenceDataDetails.submitTransferenceData.paymentType || '',
          transferAmount: this.submitTransferenceDataDetails.submitTransferenceData.totalAmount || '0.00',
          commission: this.submitTransferenceDataDetails.submitTransferenceData.commissionValue || ".00",
          totalAmount: this.submitTransferenceDataDetails.submitTransferenceData.totalAmount || '0.00',
          bonusAmount: this.submitTransferenceDataDetails.submitTransferenceData.bonusAmount || 0,
          commissionPercentage: '0',
          userName: userName,
        },
      }
    }

    delete this.submitTransferenceDataDetails.submitTransferenceData.commissionValue;
    delete this.submitTransferenceDataDetails.submitTransferenceData.accountNumber;
    delete this.submitTransferenceDataDetails.submitTransferenceData.transferDate;
    delete this.submitTransferenceDataDetails.submitTransferenceData.cardNumber;
    delete this.submitTransferenceDataDetails.submitTransferenceData.userName;

    await submitTransference(this.submitTransferenceDataDetails.submitTransferenceData).then((res) => {
    if (res.body.status.status !== 'failure') {
      this.handleClose();
      browserHistory.push(
        {
          pathname: commonUtil.getRouteByParameter(this.applicationRoutes.partialConfirmation,
            { eventID: this.eventID }),
          state: {
            submitTransferenceDetails: submitTransferenceDetails, isEmployee: this.isEmployee,
          },
        });
    } else {
      this.openErrorModal();
    }
    }).catch((e) => {
      const errorMessage = e.body?.status === 'failure' ? e.body?.message ?? "" : "";
      this.openErrorModal(errorMessage);
    });
  }

  openErrorModal = (errorMessage) => {
    this.handleClose();
    this.ErrorModal.handleShow(errorMessage);
  }

  render() {
    const channel = commonUtil.getChannel();
    const constChannels = commonUtil.getClientConstForChannel();
    const isWap = channel === constChannels.WAP;
    const brand = commonUtil.getBrand();
    const colors = { LP: '#E10098', GAP: '#122344', PB: '#970400', PBK: '#74b0e2', WS: '#e81818', WLM: '#ed2724', TRU: '#007bff' };
    const renderWeb = () => (
      <React.Fragment>
        <ErrorModal
          onRef={ref => (this.ErrorModal = ref)}
          eventId={this.eventID}
        />
        <div className="modal fade modal-custom in" style={{ display: this.state.show ? 'block' : 'none' }}>
          <div className="modal-dialog" role="document">
            <div style={{ borderRadius: '4px', backgroundColor: '#ffffff', width: '85%' }}>
              <div className="modal-body" style={{ padding: '0' }}>
                <div
                  style={{
                    padding: '18px',
                    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.15)',
                    fontSize: '18px',
                  }}
                >
                  Validemos tu identidad
                  <button
                    onClick={() => this.handleClose()}
                    className="close"
                    type="button"
                    data-dismiss="modal"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                        fill="#333333"
                      />
                    </svg>
                  </button>
                </div>
                <div style={{ display: 'flex', padding: '1rem 3rem', flexDirection: 'column', alignItems: 'center' }}>
                  <p style={{ fontSize: '16px', fontWeight: '400' }}>
                    <span>
                      Para confirmar el{' '}
                      {this.props.type === 'partial' ? 'retiro' : 'cierre'}, se
                      enviara un código de seguridad al correo electrónico:
                    </span>
                    <span style={{ fontWeight: 600 }}> {this.props.email || ''}</span>
                    <span> y al número de celular: </span>
                    <span style={{ fontWeight: 600 }}>
                      {this.props.phoneNumber || ''}
                    </span>
                  </p>
                  <div
                    className="col-xs-12"
                    style={{ textAlign: 'center' }}
                  >
                    <ReactCodeInput
                      id="codeRef"
                      type="tel"
                      fields={6}
                      ref={(ref) => {
                        this.reactCodeInput = ref;
                      }}
                      value={this.state.otpCode}
                      onChange={this.handleCodeChange}
                      autoFocus
                      inputStyle={{
                        width: '40px',
                        height: '60px',
                        margin: '10px',
                        border: `1px solid ${this.state.isCodeValid ? colors[brand] : '#FF0000'}`,
                        fontSize: '30px',
                        borderRadius: '6px',
                        textAlign: 'center',
                      }}
                    />
                    <div style={{ color: 'red', display: 'flex', fontSize: '12px', fontWeight: '300', justifyContent: "center" }}>
                      <p>{ !this.state.isCodeValid && `* ${this.state.messageError}` }</p>
                    </div>
                    <div>
                      <button
                        type="button"
                        style={{
                          marginTop: '2rem',
                          cursor: this.state.disabledButton ? 'no-drop' : 'pointer',
                          background: 'none',
                          border: 0,
                          textDecoration: 'underline',
                          color: this.state.disabledButton ? '#C0C0C0' : colors[brand],
                        }}
                        disabled={this.state.disabledButton}
                        onClick={() => this.handleBtnSendAgain()}
                      >
                        <span>Reenviar código </span>
                      </button>
                      <TimerComponent timer={this.state.timer} />
                    </div>
                    <div style={{ fontSize: '14px', fontWeight: '400', marginTop: '12px' }}>
                      <p>¿Tus datos no son correctos?<br />Actualízalos en tu Liverpool más cercano.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.show && <div className="modal-backdrop fade in" />}
      </React.Fragment>
    );
    const renderWap = () => (
      <React.Fragment>
        <ErrorModal
          onRef={ref => (this.ErrorModal = ref)}
          eventId={this.eventID}
        />
        <div style={{ margin: '0 15px' }}>
          <h3 style={{ textAlign: 'center' }}>Validemos tu identidad</h3>
          <p style={{ fontSize: '16px', fontWeight: '400' }}>
            <span>
              Para confirmar el{' '}
              {this.props.type === 'partial' ? 'retiro' : 'cierre'}, se
              enviara un código de seguridad al correo electrónico:
            </span>
            <span style={{ fontWeight: 600 }}> {this.props.email || ''}</span>
            <span> y al número de celular: </span>
            <span style={{ fontWeight: 600 }}>
              {this.props.phoneNumber || ''}
            </span>
          </p>
          <div
            className="col-xs-12"
            style={{ textAlign: 'center', padding: 0 }}
          >
            <ReactCodeInput
              id="codeRef"
              type="tel"
              fields={6}
              ref={(ref) => {
                this.reactCodeInput = ref;
              }}
              value={this.state.otpCode}
              onChange={this.handleCodeChange}
              autoFocus
              inputStyle={{
                width: '35px',
                height: '55px',
                margin: '10px 8px',
                border: `1px solid ${this.state.isCodeValid ? colors[brand] : '#FF0000'}`,
                fontSize: '30px',
                borderRadius: '6px',
                textAlign: 'center',
              }}
            />
            <div style={{ color: 'red', display: 'flex', fontSize: '12px', fontWeight: '300', justifyContent: "center" }}>
              <p>{ !this.state.isCodeValid && `* ${this.state.messageError}` }</p>
            </div>
            <div>
              <button
                type="button"
                style={{
                  marginTop: '2rem',
                  cursor: this.state.disabledButton ? 'no-drop' : 'pointer',
                  background: 'none',
                  border: 0,
                  textDecoration: 'underline',
                  color: this.state.disabledButton ? '#C0C0C0' : colors[brand],
                }}
                disabled={this.state.disabledButton}
                onClick={() => this.handleBtnSendAgain()}
              >
                <span>Reenviar código </span>
              </button>
              <TimerComponent timer={this.state.timer} />
            </div>
            <div style={{ fontSize: '14px', fontWeight: '400', marginTop: '12px' }}>
              <p>¿Tus datos no son correctos?<br />Actualízalos en tu Liverpool más cercano.</p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
    return (!isWap ? renderWeb() : renderWap());
  }
}

export default OtpCodeValidationModal;
